import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';
import CouponBox from '../CouponBox';
import styled from "styled-components";

import {
    makeStyles,
    Box,
    Grid,
    Typography,
    Button
} from "@material-ui/core";

const Dash = styled.span`
    background-image:url("/images/dash.svg");  
    width: 109%;
    left: -11px;
    height: 2px;
    display: inline-block;
    position: relative;
    ::before {
        content: url("/images/circle.svg");
        top: -13px;
        left: -33px;
        width: 29px;
        text-align: center;
        position: absolute;
        font-size: 29px;
    }
    ::after {
        content: url("/images/circle.svg");
        top: -13px;
        right: -12px;
        width: 29px;
        text-align: center;
        position: absolute;
        font-size: 29px;
        @media only screen and (max-width: 500px) {
            left: 100%
        }
    }
`;

const useStylesAll = makeStyles(theme => ({
    pageContainer: {
        display: "flex",
        justifyContent: "center",
    },
    container: {
        fontFamily: "Poppins",
        width: "100%",
        color: "#000000",
        padding: "10px 15px",
        [theme.breakpoints.up('md')]: {
            width: "85%",
            maxWidth: 570,
            padding: "30px",
        },
        marginTop: '50px'
    },
    bigCoupon: {
        minWidth: "280px",
        backgroundColor: "#D4A6A5",
        color: "#FFFFFF",
        padding: "20px 30px",
        textAlign: "center",
        position: "relative",
        [theme.breakpoints.up('sm')]: {
            padding: "30px 30px",
        },
        '& > $title': {
            fontWeight: "700",
            color: "#FFFFFF",
            fontSize: "26px",
            lineHeight: "39px",
            [theme.breakpoints.up('sm')]: {
                fontSize: "36px",
                lineHeight: "54px"
            },
        },
        '& > $date': {
            color: "#FFFFFF",
            fontSize: "14px",
            lineHeight: "21px",
            [theme.breakpoints.up('sm')]: {
                fontSize: "16px",
                lineHeight: "24px",
            },
        },
        '& > $line': {
            minWidth: "167px",
            width: "100%",
            position: "absolute",
            left: 0,
            marginTop: "8px",
            [theme.breakpoints.up('sm')]: {
                width: "237px",
                marginTop: 0,
            },
        },
        
        '&.expired': {
            backgroundColor: "#CCCCCC",
            '& > $btn': {
                color: "#CCCCCC",
            },
        },
        '& > $tnc': {
            textAlign: "left",
            marginBottom: "20px",
            color: "#FFFFFF"
        },
    },
    title: {},
    date: {},
    line: {},
    btn: {},
    tnc: {},
    code: {},
    codeContainer: {
        backgroundColor: "#FFFFFF",
        width: "100%",
        margin: "0 auto",  
        marginTop: "20px",
        marginBottom: "35px"
    },
    codeInput: {
        border: "none",
        color: "#666666",
        padding: "13px 10px",
        fontSize: "16px",
        '&:focus': {
            outline: "none"
        },
    },
    copyBtn: {
        backgroundColor: "#FFFFFF",
        color: "#D4A6A5",
        padding: "10px 15px",
        whiteSpace: "nowrap",
        fontWeight: "400",
        border: "1px solid #D4A6A5",
        margin: "5px",
    },
}));


function CouponPage(props) {
    const { t, i18n } = useTranslation('register');
    const classes = useStylesAll();
    const [isDisabled, setIsDisabled] = React.useState(true);
    const [amount, setAmount] = React.useState("10");
    const [validUntil, setValidUntil] = React.useState("2022/11/13");
    const [expired, setExpired] = React.useState(false);
    const [couponCode, setCouponCode] = React.useState("48duW8402a");

    const history = useHistory();

    function toLogin() {
        history.push("/login");
    }

    return (
        <Box className={classes.pageContainer}>
            <Box className={classes.container}>
                <Grid container justifyContent="center" spacing={4}>
                    <Grid item xs={12} style={{maxWidth: "570px"}}>
                        <Typography variant="h1">{t('Coupon Details')}</Typography>
                        <Box className={expired ? `${classes.bigCoupon} expired` : `${classes.bigCoupon}`}>
                            <Typography className={classes.title}>${amount} {t('coupon')}</Typography>
                            <Typography className={classes.date}>{t('Valid till')} {validUntil}</Typography>

                            <Box className={classes.codeContainer}>
                                <Grid container container direction="row"
                                    justifyContent="space-between"
                                    alignItems="center">
                                    <Grid item xs={6} style={{textAlign: "left"}}>
                                        <input type="text" className={classes.codeInput} value={couponCode}/>
                                    </Grid>
                                    <Grid item xs={6} style={{textAlign: "right"}}>
                                        <Button type="button" className={classes.copyBtn} onClick={() => {navigator.clipboard.writeText(couponCode)}}>
                                            {t('Copy Code')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                            
                            <Dash/>

                            <Typography className={classes.tnc} variant="h2">{t('Terms & Conditions')}</Typography>

                            <Typography className={classes.tnc} variant="body2">1. Information on how to participate forms part of these Terms & Conditions. By participating, claimants agree to be bound by these Terms & Conditions. Claimants must comply with these Terms & Conditions for a coupon to be valid.</Typography>
                            <Typography className={classes.tnc} variant="body2">2. Each claimant is entitled to one coupon per accommodation establishment. Coupons are not transferable and are not redeemable for cash and cannot be combined with any other coupons or any other offer or discounts or promotions offered by Quovai.</Typography>
                            <Typography className={classes.tnc} variant="body2">3. Each coupon is identified by a code and has different rewards. The claimant can decide the reward desired during the booking phase whilst being bound by the conditions linked to the redemption of the coupon.</Typography>

                        </Box>
                        <Button type="submit" className={classes.btn} variant="contained" fullWidth style={{marginTop: "40px"}} onClick={() => {}}>{t('Shop Now')}</Button>
                    </Grid>

                </Grid>
            </Box>
        </Box>
    );
}

export default CouponPage;
